module.exports = __webpack_public_path__ + "img/prodpage_4.baacc5fa.png";